import { render, staticRenderFns } from "./LandingValues.vue?vue&type=template&id=da4a751a&"
import script from "./LandingValues.vue?vue&type=script&lang=js&"
export * from "./LandingValues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports